import { Box, Modal } from "@mui/material"
import { RoleControllerAction, RoleControllerState } from "../../controller/role.controller"
import { RoleModalChildrenData } from "../../data/role.modal.child";

const RoleModalView = ({ ctrl }: { ctrl: RoleControllerState & RoleControllerAction }) => {

    var model = RoleModalChildrenData.filter(
        (item) => ctrl?.activeModal !== null && item.name.includes(ctrl?.activeModal?.name)
    )[0] ?? null;
    return (
        <Modal
            open={ctrl.activeModal != null}
            onClose={() => ctrl.onHandleModal(null)}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflowY: 'auto' }}
        >
            <Box
                sx={{
                    bgcolor: 'white',
                    width: '100%',
                    maxWidth: '900px',
                    borderRadius: '12px',
                    maxHeight: { xs: '90vh', md: '800px' },
                    overflow: 'hidden',
                }}
            >
                <Box>
                    {model != null ? <model.child ctrl={ctrl} /> : null}
                </Box>
            </Box>
        </Modal >
    )
}

export default RoleModalView;